/* eslint-disable import/prefer-default-export */
import { useAppSelector } from 'app/hooks'

export const usePageConfigState = () => {
  const pageConfigState = useAppSelector(({ pageConfig }) => pageConfig)
  return pageConfigState
}

export const usePageConfig = () => {
  const config = useAppSelector(({ pageConfig }) => pageConfig.config)
  return config
}

export const usePageConfigUser = () => {
  const config = useAppSelector(({ pageConfig }) => pageConfig.config.user)
  return config
}

export const usePageConfigAccount = () => {
  const config = useAppSelector(({ pageConfig }) => pageConfig.config.account)
  return config
}

export const useThirdPartySettings = () => {
  const config = useAppSelector(({ pageConfig }) => pageConfig.config.thirdPartySettings)
  return config
}

export const useFeatureFlags = () => {
  const config = useAppSelector(({ pageConfig }) => pageConfig.config.featureFlags)
  return config
}

export const useApplicationSettings = () => {
  const config = useAppSelector(({ pageConfig }) => pageConfig.config.applicationSettings)
  return config
}

export const useAccountId = () => {
  const accountId = useAppSelector(({ pageConfig }) => pageConfig.config.account?.accountId)
  return accountId
}
